import { GetAllNotifiche2023FiltersDTO, GetAllNotifiche2023ResponseData } from "./dto";
import { MonitoringNotifiche2023Impl } from "./serviceImpl";

export interface MonitoringNotifiche2023Service {
    GetAllNotifiche2023(filters: GetAllNotifiche2023FiltersDTO): Promise<GetAllNotifiche2023ResponseData[]>
}

export function NewMonitoringNotifiche2023Service(): MonitoringNotifiche2023Service {
    return new MonitoringNotifiche2023Impl()
}